import { render, staticRenderFns } from "./PxCards.vue?vue&type=template&id=02297224&scoped=true&lang=pug&"
import script from "./PxCards.vue?vue&type=script&lang=js&"
export * from "./PxCards.vue?vue&type=script&lang=js&"
import style0 from "./PxCards.vue?vue&type=style&index=0&id=02297224&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02297224",
  null
  
)

export default component.exports